import React from "react";

import useBook from "../../hooks/useBook";

import ArchiveCanvas from "../../shared_comp/ArchiveCanvas";
import SectionTitle from "../../shared_comp/SectionTitle";
import MainCanvas from "../../shared_comp/MainCanvas";
import Working from "../../shared_comp/Working";


const DocumentMain = () => {


  const [bookList, setBookList] = React.useState<any>([])

  React.useEffect(() => {
    const receiveData = async () => {

        //  to do : 조선총독부 관보, 직원록, 만주국 관보, 일본 관보, 대한민국 관보, 등 여러 카테고리로 나누어야 함
        // 조선총독부 관보
        const resA = await useBook.getBookList("official report")
        // 만주국 관보
        const resB = await useBook.getBookList("official_report")

        let books_A = []
        let books_B = []

        if (resA.result){books_A = resA.books}
        if (resB.result){books_B = resB.books}

        let bookList = [...books_A, ...books_B]
        console.log("bookList", bookList)

        // add publish_month, publish_day from publish_date
        bookList = bookList.map((book: any) => {
            let pdate = book.publish_date
            // check format of publish_date
            if (pdate === undefined || pdate === null || pdate === ""){
                book.publish_month = 0
                book.publish_day = 0
                if (book.publish_year === undefined || book.publish_year === null || book.publish_year === ""){
                    book.publish_year = 9999
                }
            } else if (pdate.length === 10 && pdate[4] === "-" && pdate[7] === "-"){
                book.publish_month = parseInt(pdate.slice(5, 7))
                book.publish_day = parseInt(pdate.slice(8, 10))
            } else if (pdate.includes("년") && pdate.includes("월")){
                let pdate_div = pdate.split("년")
                let month = parseInt(pdate_div[1].split("월")[0])
                book.publish_month = month;
                if(pdate_div[1].split("월")[1].includes("일")){
                    let day = parseInt(pdate_div[1].split("월")[1].split("일")[0])
                    book.publish_day = day
                } else {
                    book.publish_day = 0
                }
            } else if (pdate.includes("年") && pdate.includes("月")){
                let pdate_div = pdate.split("年")
                let month = parseInt(pdate_div[1].split("月")[0])
                book.publish_month = month;
                if(pdate_div[1].split("月")[1].includes("日")){
                    let day = parseInt(pdate_div[1].split("月")[1].split("日")[0])
                    book.publish_day = day
                } else {
                    book.publish_day = 0
                }
            } else if (pdate === 'n.r.') {
                book.publish_year = 9999
                book.publish_month = 0
                book.publish_day = 0
            } else {
                book.publish_month = 0
                book.publish_day = 0
                console.log("new format of publish_date", pdate)
            }
            return book
        })

        // sort by publish_year, publish_month, publish_day
        bookList.sort((a: any, b: any) => {
            if (a.publish_year > b.publish_year){
                return 1
            } else if (a.publish_year < b.publish_year){
                return -1
            } else {
                if (a.publish_month > b.publish_month){
                    return 1
                } else if (a.publish_month < b.publish_month){
                    return -1
                } else {
                    if (a.publish_day > b.publish_day){
                        return 1
                    } else if (a.publish_day < b.publish_day){
                        return -1
                    } else {
                        return 0
                    }
                }
            }
        })
        console.log("bookList sorted", bookList)

        setBookList(bookList)
    }
    receiveData()
  }, [])

  return (
    <ArchiveCanvas>
      <SectionTitle title="정부자료 / 기타정부문서" />
      <MainCanvas>
        <Working />
      </MainCanvas>
    </ArchiveCanvas>);
};
export default DocumentMain;
